export const BASEURL = "https://educourse.id";

// login
export const URL_LOGIN = `${BASEURL}/api-agency/login/ `;

// register
export const URL_REGISTER_AGENCY = `${BASEURL}/api-agency/registrationagency/ `;
export const URL_REGISTER_RESELLER = `${BASEURL}/api-agency/registrationreseller/ `;

// daftar user yang sudah ada mejadi reseller
export const URL_UPDATE_INFO_RESELLER = `${BASEURL}/api-agency/addreseller/ `;

// profile
export const URL_AGENCY_PROFILE = `${BASEURL}/api-agency/agencyprofile/`;
export const URL_RESELLER_PROFILE = `${BASEURL}/api-agency/resellerprofile/`;

// commission
export const URL_RESELLER_COMMISSION_STATS = `${BASEURL}/api-agency/statisticcommissionreseller/`;
export const URL_AGENCY_COMMISSION_STATS = `${BASEURL}/api-agency/statisticcommissionagency/`;

// blast email
export const URL_BLASTEMAIL_RESELLER = `${BASEURL}/api-agency/agencyblastemail/`;

export const URL_CASHFLOW = `${BASEURL}/api-agency/cashflow/`;
export const URL_CASHFLOW_BY_USER = `${BASEURL}/api-agency/cashflowbyuser/`;

// admin
export const URL_ALL_EXPERT = `${BASEURL}/api-agency/agency/`;
export const URL_ALL_BASIC = `${BASEURL}/api-agency/reseller/`;
export const URL_ALL_EXPERTID = `${BASEURL}/api-agency/agencyprofilebyid/`;
export const URL_ALL_BASICID = `${BASEURL}/api-agency/resellerprofilebyid/`;
export const URL_ALL_WITHDRAW = `${BASEURL}/api-agency/cashflowbytype/`;

// e
export const URL_EVENT = `${BASEURL}/api-agency/event/`;
export const URL_HISTORY = `${BASEURL}/api-agency/history/`;

// on boarding
export const URL_ONBOARDING_CLASS = `${BASEURL}/api-agency/onboardingbyidcourse/`;


export const OPTIONS = (token) => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  };
};

export const OPTIONS_FORM_DATA = (token) => {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Token " + token,
    },
  };
};

export const OPTIONS_FORM_DATA_WITHOUT_TOKEN = () => {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
};
